<template>
  <div>
    <ds-content-header>
      <div slot="left">
        <ds-breadcrumbs :breadcrumbs="breadcrumbs" />
      </div>
    </ds-content-header>
    <div class="columns">
      <div class="column is-6">
        <ds-content-box>
          <div slot="content">
            <dns-tool-form @onSubmit="onSubmit" />
          </div>
        </ds-content-box>
      </div>
    </div>

    <div
      v-if="isFetching || result || fetchingError"
      class="columns"
    >
      <div class="column is-6">
        <ds-content-box>
          <div slot="content">
            <div class="gray-background-inner">
              <ds-loader
                :is-loading="isFetching"
                full-height
              >
                <div
                  v-html="result"
                  class="response-box"
                >

                  <div v-if="fetchingError">
                    Wystąpił błąd podczas wykonywania komendy.
                  </div>
                </div>
              </ds-loader>
            </div>
          </div>
        </ds-content-box>
      </div>
    </div>
  </div>
</template>

<script>
import ToolboxService from "@/app/dashboard/services/toolbox.service";
import DnsToolForm from "../forms/dns-tool-form/dns-tool-form";

export default {
  components: {
    DnsToolForm
  },
  data() {
    return {
      result: null,
      isFetching: false,
      fetchingError: false
    };
  },
  computed: {
    breadcrumbs() {
      return {
        top: [
          {
            url: {
              name: "dns-tool"
            },
            displayName: "DNS tool"
          }
        ],
        bottom: []
      };
    }
  },
  methods: {
    async onSubmit(address, type, resolver, options) {
      this.isFetching = true;
      this.fetchingError = false;
      this.result = "";
      let resultData;

      try {
        resultData = await ToolboxService.dnsTool({
          address,
          type,
          resolver,
          ...options
        });
        this.result =
          resultData.data.length === 0
            ? "No data"
            : resultData.data.replace(/\n/g, "<br />");
      } catch (e) {
        this.fetchingError = true;
      }
      this.isFetching = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/app/dashboard/views/dns-tool.vue